import { DEFAULT_CRUISE_SEARCH_PAGE_ID, DEFAULT_CRUISE_SEARCH_PAGE_NAME } from 'src/common/constants/pages';
import loadable from '@loadable/component';
export class CruiseSearchController {
  constructor() {
    this.bundles = ['cruisesearch'];
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "search";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: () => import( /* webpackChunkName: "search" */'src/common/views/cruise/search'),
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("src/common/views/cruise/search");
        }
        return eval('require.resolve')("src/common/views/cruise/search");
      }
    });
    this.pageId = DEFAULT_CRUISE_SEARCH_PAGE_ID;
    this.path = '/Cruise-Search';
    this.exact = true;
    this.routeName = 'CruiseSearch';
    this.routeData = {
      rfrrNamespace: 'CR.SR',
      pageName: DEFAULT_CRUISE_SEARCH_PAGE_NAME
    };
  }
  fetch() {
    return Promise.resolve();
  }
  fetchPageData() {
    return Promise.resolve({
      title: 'Cruise Searches | Expedia',
      seo: {
        robots: 'noindex'
      },
      pageName: DEFAULT_CRUISE_SEARCH_PAGE_NAME
    });
  }
}